import { useEffect, useState } from 'react';

// SSR (PDF service) has no `window`; fall back to a desktop size so layouts render as desktop.
const SSR_WINDOW_SIZE = { width: 1920, height: 1080 };

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState(() =>
        typeof window === 'undefined' ? SSR_WINDOW_SIZE : { width: window.innerWidth, height: window.innerHeight }
    );
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowSize;
};

export default useWindowSize;
